// extracted by mini-css-extract-plugin
export default {"querypage":"Count_querypage__SLHCm","table":"Count_table__ihy7X"};